const API = 'https://jz0akk4yg4.execute-api.us-west-2.amazonaws.com/default/save-custom-page';
async function publicPages(host, slug) {
  const response = await fetch(`${API}?host=${encodeURIComponent(host)}${slug ? '&slug='+encodeURIComponent(slug) : ''}`, { cache:'no-store' });
  if(response.status===404)return slug?null:[];
  if(!response.ok)throw Error('Custom pages are temporarily unavailable. Please retry.');
  const data=await response.json();
  if(slug){if(!data.page||typeof data.page.title!=='string'||!Array.isArray(data.page.sections)||data.page.slug!==slug)throw Error('This page could not be loaded.');return data.page;}
  if(!Array.isArray(data.pages)||data.pages.some(p=>typeof p.title!=='string'||typeof p.slug!=='string'))throw Error('The page list could not be loaded.');
  return data.pages;
}
// Retain the existing helper contract while passing a host, never a private author folder.
export const fetchAuthorFolderForHost = async host => host;
export const fetchCustomPageIndex = host => publicPages(host);
export const fetchCustomPageBySlug = ({authorFolder,slug}) => publicPages(authorFolder,slug);
export const fetchCustomPagesForHost = async host => ({folder:host,pages:await publicPages(host)});
